import FlashMessage from '~/models/FlashMessage'

export default () => {
    return useCookie<FlashMessage[]>('nextFlashMessages', {
        maxAge: 60, // 60 seconds
        secure: true,
    })
}
